<p-dialog
  [header]="entryFormHeader()"
  [(visible)]="showEntryDialog"
  showEffect="fade"
  [modal]="true"
  [transitionOptions]="'0ms'"
  (onHide)="onEntryDialogHide()"
  [style]="{ width: '1000px' }"
>
  @if (!entryFormWorking()) {
    <form [formGroup]="entryForm" class="form">
      <div id="add-entry-create-form">
        <div class="panel">
          <div class="form-body">
            <div class="top-fields">
              <span class="label"
                >{{ 'CRM.LABEL.DOP_LABELS' | translate }}:
              </span>
              <span class="label-wrapper">
                <p-select
                  formControlName="label"
                  [options]="labels"
                  placeholder="{{
                    'CRM.MESSAGES.PLACEHOLDER.DOP_LABEL' | translate
                  }}"
                />
              </span>

              <span class="radio-wrapper">
                <label for="active">{{
                  'DOP.LABEL.BUTTONS.ACTIVE' | translate
                }}</label>
                <p-radiobutton
                  name="active"
                  [value]="true"
                  formControlName="active"
                  styleClass="radio"
                />
              </span>
              <span class="radio-wrapper">
                <label for="active">{{
                  'DOP.LABEL.BUTTONS.INACTIVE' | translate
                }}</label>
                <p-radiobutton
                  name="active"
                  [value]="false"
                  formControlName="active"
                  styleClass="radio"
                />
              </span>
            </div>
            <span class="label">{{ 'DOP.LABEL.COMMENT' | translate }}:</span>

            @if (showEntryDialog) {
              <app-note-editor
                formControlName="entryText"
                (textChange)="validateForm()"
              />
            }
          </div>

          <div class="modal-buttons">
            <button
              pButton
              label="{{ 'COMMON.LABEL.BUTTONS.OK' | translate }}"
              icon="fa fa-fw fa-check"
              (click)="saveEntry()"
              [disabled]="!this.entryForm.valid"
            ></button>
            <button
              pButton
              label="{{ 'COMMON.LABEL.BUTTONS.CANCEL' | translate }}"
              icon="fa fa-fw fa-ban"
              (click)="onEntryDialogHide()"
            ></button>
          </div>
        </div>
      </div>
    </form>
  } @else {
    <app-progress-spinner [enabled]="entryFormWorking()" />
  }
</p-dialog>
